// Used for mobile main menu
document.addEventListener(
  'DOMContentLoaded', () => {
    const menu = new MmenuLight(
      document.querySelector('#manager-menu'),
      '(min-width: 320px)',
    );
    // Init main menu for mobile
    const menuMain = new MmenuLight(
      document.querySelector('#main-menu'),
      '(max-width: 992px)',
    );
    // below is needed for framework, so eslint can ignore
    /* eslint-disable no-unused-vars */
    const navigator = menu.navigation({
      theme: 'dark',
      title: 'Admin Menu',
    });
    // below is needed for framework, so eslint can ignore
    /* eslint-disable no-unused-vars */
    const navigatorMain = menuMain.navigation({
      theme: 'dark',
      title: 'Main Menu',
    });
    const drawer = menu.offcanvas({
      position: 'right',
    });
    const drawerMain = menuMain.offcanvas({
      position: 'left',
    });
    const toggle = (elem) => {
      const drawerOpen = document.querySelector('.mm-ocd.mm-ocd--open');
      if (drawerOpen) {
        jQuery(elem).show();
        return;
      }

      jQuery(elem).hide();
    };
    document.querySelector("a[href='#main-menu']")
      .addEventListener('click', (event) => {
        event.preventDefault();
        drawerMain.open();
        toggle(document.querySelector('#main-menu'));
      });
    document.querySelector("a[href='#manager-menu']")
      .addEventListener('click', (event) => {
        event.preventDefault();
        drawer.open();
        toggle(document.querySelector('#manager-menu'));
      });
    const selectors = document.querySelectorAll('.first-level-item.manager-menu span.list-item');
    selectors.forEach((target) => {
      target.addEventListener('click', (event) => {
        const t = event.target.children[1];
        const title = t.innerText;

        setTimeout(() => {
          const elm = document.querySelector('.mm-spn.mm-spn--navbar');
          elm.setAttribute('data-mm-spn-title', title);
        }, 10);
      });
    });
  },
);
